module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xs,
      "max-width": "600px"
    },
    model: {
      value: (_vm.bottomsheet),
      callback: function($$v) {
        _vm.bottomsheet = $$v
      },
      expression: "bottomsheet"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "overline py-0 grey lighten-2"
  }, [(_vm.activeWindow === 1) ? _c('v-btn', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")])], 1) : _vm._e(), _vm._v("\n        Choose an appointment type\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomsheet = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "dark": ""
    }
  }, [(_vm.practitioner) ? _c('practitioner-list-item', {
    attrs: {
      "item": _vm.practitioner
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeWindow > 0) ? _c('v-footer', {
    staticClass: "pl-4"
  }, [_vm._v(_vm._s(_vm.selectedService.title))]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.activeWindow),
      callback: function($$v) {
        _vm.activeWindow = $$v
      },
      expression: "activeWindow"
    }
  }, [_c('v-window-item', {
    key: 0
  }, [_c('v-card', {
    staticClass: "rounded",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "rounded",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.spaces), function(service, index) {
    return [_c('v-list-tile', {
      key: (index + "-" + (service.id)),
      staticClass: "grey lighten-2 py-1 mt-4 elevation-5",
      class: ['staticClass', service.collapsed ? 'rounded' : 'rounded-collapsed'],
      on: {
        "click": function($event) {
          return _vm.toggleService(service)
        }
      }
    }, [(_vm.spaces && _vm.spaces.length > 1) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [(service.collapsed === true) ? _c('v-icon', [_vm._v("expand_more")]) : _c('v-icon', [_vm._v("expand_less")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-avatar', [(service.logo_picture) ? _c('v-img', {
      attrs: {
        "src": service.logo_picture
      }
    }) : _c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("star_outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(service.title)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [(service.locations && service.locations.length === 1) ? _c('span', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("location_on")]), _vm._v("\n                          " + _vm._s(service.locations[0].name) + "\n                        ")], 1) : _vm._e(), _vm._v(" "), (service.role) ? _c('v-chip', {
      staticClass: "v-chip--x-small ml-0",
      attrs: {
        "color": _vm.roleColor(service.role),
        "dark": "",
        "outline": ""
      }
    }, [_vm._v("\n                          " + _vm._s(service.role) + "\n                        ")]) : _vm._e(), _vm._v(" "), (service.members && service.members.length > 1) ? _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            staticClass: "v-chip--x-small ml-0",
            attrs: {
              "color": "info",
              "dark": "",
              "outline": ""
            }
          }, on), [_vm._v("\n                              shared space\n                            ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("All members of this space will be able to see this appointment")])]) : _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-chip', _vm._g({
            staticClass: "v-chip--x-small ml-0",
            attrs: {
              "color": "info",
              "dark": "",
              "outline": ""
            }
          }, on), [_vm._v("\n                              Private\n                            ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("You are currently the only member of this space")])])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "mr-5"
    }, [_c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "icon": "",
              "href": ("" + (_vm.LINKS.SETTINGS_SPACES) + (service.id)),
              "disabled": !_vm.canManageSpace(service),
              "target": "_blank"
            }
          }, on), [_c('v-icon', [_vm._v("open_in_new")])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v("Manage this space")])])], 1), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
      attrs: {
        "small": "",
        "fab": "",
        "top": "",
        "right": "",
        "absolute": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.selectedService = service;
          _vm.activeWindow = 1
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), (!service.collapsed) ? _c('v-divider', {
      key: ("div-" + (service.id))
    }) : _vm._e(), _vm._v(" "), (service.collapsed !== true) ? [(service.locations && service.locations.length <= 1) ? _c('v-card', {
      key: ("noloc-" + (service.id))
    }, [_vm._l((_vm.getProducts(_vm.practitioner.id, service.id, null)), function(product, index) {
      return [(product.archived !== true) ? _c('v-list-tile', {
        key: ("p-" + (product.id) + "-" + (service.id) + "-noloc-" + index),
        on: {
          "click": function($event) {
            return _vm.setSelected(service, service.locations, product.id)
          }
        }
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
        domProps: {
          "textContent": _vm._s(product.title)
        }
      })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
        key: ("div-" + (product.id) + "-noloc-" + (service.id) + "-" + (_vm.practitioner.id) + "-" + index)
      })]
    }), _vm._v(" "), (service.locations.length === 0) ? _c('v-card-actions', [_c('span', {
      staticClass: "ml-2"
    }, [_vm._v("No locations defined.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.gotoLocation(service)
        }
      }
    }, [_vm._v("Create one?")]) : _vm._e()], 1) : [(_vm.getProducts(_vm.practitioner.id, service.id, null).length === 0) ? _c('v-card-actions', [_c('span', {
      staticClass: "ml-2"
    }, [_vm._v("No appointment types defined.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedService = service;
          _vm.activeWindow = 1
        }
      }
    }, [_vm._v("Create one?")]) : _vm._e()], 1) : _vm._e()]], 2) : _vm._l((service.locations), function(location) {
      return _c('v-card', {
        key: ((service.id) + "-" + (location.id))
      }, [_c('v-card-title', {
        key: ("loc-" + (location.id)),
        staticClass: "pl-0 py-0 grey lighten-5",
        on: {
          "click": function($event) {
            return _vm.togglelocation(location)
          }
        }
      }, [(service.locations.length > 1) ? _c('v-btn', {
        attrs: {
          "icon": "",
          "small": ""
        }
      }, [(location.collapsed === true) ? _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("expand_more")]) : _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("expand_less")])], 1) : _vm._e(), _vm._v(" "), _c('v-icon', {
        attrs: {
          "color": "primary"
        }
      }, [_vm._v("location_on")]), _vm._v(" "), _c('strong', {
        staticClass: "overline",
        domProps: {
          "textContent": _vm._s(location.name)
        }
      }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (location.collapsed === true) ? _c('v-chip', {
        staticClass: "caption",
        attrs: {
          "outline": "",
          "small": "",
          "color": "primary"
        }
      }, [_vm._v("\n                            " + _vm._s(_vm.getProducts(_vm.practitioner.id, service.id, location.id).length) + "\n                          ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (location.collapsed !== true) ? [_vm._l((_vm.getProducts(_vm.practitioner.id, service.id, location.id)), function(product, index) {
        return [(product.archived !== true) ? _c('v-list-tile', {
          key: ("p-" + (product.id) + "-" + (service.id) + "-" + (location.id) + "-" + index),
          on: {
            "click": function($event) {
              return _vm.setSelected(service, location, product.id)
            }
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "textContent": _vm._s(product.title)
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
          key: ("div-" + (product.id) + "-" + (location.id) + "-" + (service.id) + "-" + (_vm.practitioner.id) + "-" + index)
        })]
      }), _vm._v(" "), (_vm.getProducts(_vm.practitioner.id, service.id, location.id).length === 0) ? _c('v-card-actions', [_c('span', {
        staticClass: "ml-2"
      }, [_vm._v("No appointment types defined.")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.canAddProduct(service)) ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": ""
        },
        on: {
          "click": function($event) {
            _vm.selectedService = service;
            _vm.activeWindow = 1
          }
        }
      }, [_vm._v("Create one?")]) : _vm._e()], 1) : _vm._e()] : _vm._e()], 2)
    })] : _vm._e(), _vm._v(" "), (service.collapsed !== true) ? _c('v-footer', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "pa-1",
      attrs: {
        "small": "",
        "outline": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.selectedService = service;
          _vm.activeWindow = "location"
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("add")]), _vm._v(" New location\n                    ")], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider')]
  })], 2), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outline": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = "space"
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v(" New space\n                ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.bottomsheet = false
      }
    }
  }, [_vm._v("\n                  cancel\n                ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.getMeReq.loading,
      "small": "",
      "outline": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")]), _vm._v(" Refresh\n                ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', {
    key: 1
  }, [_c('request-status', {
    attrs: {
      "request": _vm.saveRequest
    }
  }), _vm._v(" "), _c('appointment-type', {
    attrs: {
      "practitioner": _vm.practitioner,
      "service": _vm.selectedService,
      "withTitle": false,
      "withCancel": true,
      "loading": _vm.saveRequest.loading
    },
    on: {
      "cancel": function($event) {
        _vm.activeWindow = 0
      },
      "save": _vm.addProduct,
      "add:location": function($event) {
        return _vm.gotoLocation(_vm.selectedService)
      }
    }
  })], 1), _vm._v(" "), _c('v-window-item', {
    key: 2,
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "size": 72,
      "color": "success"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('h3', {
    staticClass: "subheading mb-4"
  }, [_vm._v("Product added")]), _vm._v(" "), (_vm.globalInitRequestLoading) ? [_c('v-progress-circular', {
    staticClass: "pb-4",
    attrs: {
      "indeterminate": "",
      "color": "amber"
    }
  }), _vm._v(" Updating profile\n            ")] : _vm._e(), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "rounded px-5 mt-4",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_vm._v("Done")])], 1)], 2), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": "space"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v("\n                Add a new space\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": _vm.LINKS.SETTINGS_SPACES,
      "small": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n                  Manage spaces\n                  "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('space-wizard', {
    on: {
      "cancel": function($event) {
        _vm.activeWindow = 0
      },
      "success": _vm.spaceCreated
    }
  })], 1)], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": "location"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.activeWindow = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("arrow_back")])], 1), _vm._v("\n                Add a new location\n                "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "href": ((_vm.LINKS.SETTINGS_SPACES) + "--/locations"),
      "small": "",
      "outline": "",
      "color": "primary"
    }
  }, [_vm._v("\n                  Manage locations\n                  "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), (_vm.selectedService && _vm.selectedService.id) ? _c('location-wizard', {
    attrs: {
      "space-id": _vm.selectedService.id,
      "space": _vm.selectedService,
      "success-steps": _vm.locationSuccessSteps,
      "touch": _vm.touchLocation
    },
    on: {
      "cancel": function($event) {
        _vm.activeWindow = 0
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32055b19","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/ProductSheet.vue
// module id = 1382
// module chunks = 9